export default __webpack_public_path__ + "static/media/Greta2.7ae5ca50.jpg";